import { useState } from "react";
import { Container, TextField, Button, Typography, Box } from "@mui/material";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Header from "./Header";
import Footer from "./Footer";
import { getSections } from "./common";
import { restUrlContact } from "./common";
import CircularProgress from "@mui/material/CircularProgress";

export default function Contact() {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState({ message: "", error: false });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: false }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    for (const key in formData) {
      if (!formData[key]) {
        newErrors[key] = true;
      }
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setStatus({ message: "", error: false });
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${restUrlContact}`, formData);
      setStatus({ message: t("messageSent"), error: false });
      setFormData({ name: "", email: "", subject: "", message: "" });
      setErrors({});
    } catch (err) {
      console.error("Email failed:", err);
      setStatus({ message: t("failedToSendMessage"), error: true });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container sx={{ mt: 4 }}>
      <Header title={t("title")} sections={getSections(t)} />
      <Typography variant="h4" gutterBottom>
        {t("contactUs")}
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label={t("name")}
          name="name"
          fullWidth
          margin="normal"
          value={formData.name}
          onChange={handleChange}
          error={!!errors.name}
        />
        <TextField
          label={t("email")}
          name="email"
          type="email"
          fullWidth
          margin="normal"
          value={formData.email}
          onChange={handleChange}
          error={!!errors.email}
        />
        <TextField
          label={t("subject")}
          name="subject"
          fullWidth
          margin="normal"
          value={formData.subject}
          onChange={handleChange}
          error={!!errors.subject}
        />
        <TextField
          label={t("message")}
          name="message"
          multiline
          rows={5}
          fullWidth
          margin="normal"
          value={formData.message}
          onChange={handleChange}
          error={!!errors.message}
        />
        <Box mt={2}>
          <Button type="submit" variant="contained" disabled={submitting}>
            {submitting ? (
              <>
                <CircularProgress size={18} color="inherit" sx={{ mr: 1 }} />
                {t("sending")}
              </>
            ) : (
              t("send")
            )}
          </Button>
        </Box>
        {status.message && (
          <Typography
            sx={{ mt: 2, color: status.error ? "error.main" : "text.primary" }}
          >
            {status.message}
          </Typography>
        )}
      </form>
      <Footer title={t("footerTitle")} description={t("footerDesc")} />
    </Container>
  );
}
